import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { IUser } from 'src/app/core/models/user.model';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-client-item',
  templateUrl: './client-item.component.html',
  styleUrls: ['./client-item.component.css']
})
export class ClientItemComponent implements OnInit, OnChanges {
  @Input() application;
  @Input() customer;
  @Input() customerId;
  @Input() customerSettings;
  @Input() selectedApp;
  @Input() currentUser;
  @Output() onShowUsers = new EventEmitter<string>();
  @Output() editClient = new EventEmitter<string>();
  @Output() changeCustomer = new EventEmitter<string>();
  @Output() invoiceConfig = new EventEmitter<string>();
  @Output() sshSetup = new EventEmitter<string>();

  urlParams;
  customers: IUser[];
  creditsLimit = null;

  constructor(public router: Router,  public route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((queryParams:any) => {
      this.urlParams = queryParams;
     });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerSettings']) {
      if(changes['customerSettings'].currentValue) {
        this.creditsLimit = changes['customerSettings'].currentValue.creditsNotificationThreshold;
      }
    }
  }

  showUsers(application) {
    this.onShowUsers.emit(application);
  }
  onEditClient(application) {
    this.editClient.emit(application);
  }
  onChangeCustomer(application) {
    this.changeCustomer.emit(application);
  }
  onInvoiceConfig(application) {
    this.invoiceConfig.emit(application)
  }

  onSSHSetup(application) {
    this.sshSetup.emit(application)
  }
}
